import { contentPadding } from "theme/components/wrappers/ContentWrapper";
import responsiveBreakpointsStyle from "core-web/utils/responsiveBreakpointsStyle";
import styled from "theme/libs/styled";

/**
 * Used to negate the padding from ContentWrapper.
 * Useful if some content inside a ContentWrapper should cover the fullwidth of the viewport
 */

const BleedWrapper = styled("div", {
    shouldForwardProp: (prop) => ["customContentPadding"].indexOf(prop) === -1,
})`
    position: relative;

    ${({ customContentPadding }) =>
        responsiveBreakpointsStyle(
            customContentPadding || contentPadding,
            "margin-left: -{value}px; margin-right: -{value}px;",
        )}
`;

export default BleedWrapper;
